// The currencies and the arithmetic between them.
//
// The Haitian dollar is not a banknote: it is five goud, a unit prices are
// quoted in. So everything pivots through goud — the foreign currency × rate,
// HTD × 5. The foreign currency is one of four: the US dollar by default, or
// the euro, the Canadian dollar or the Dominican peso.

export const FOREIGN = ['usd', 'eur', 'cad', 'dop'];
export const GOUD_PER_HTD = 5;

/** The rows, in the order they are shown and the order the answer names them in. */
export const rows = (foreign = 'usd') => ['htg', 'htd', foreign];
export const CURRENCIES = rows('usd');

/** The same sum in all three currencies. `rate` is goud per unit of `foreign`. */
export function convert(amount, from, rate, foreign = 'usd') {
  const htg = from === foreign ? amount * rate : from === 'htd' ? amount * GOUD_PER_HTD : amount;
  return { [foreign]: htg / rate, htg, htd: htg / GOUD_PER_HTD };
}

const twoDecimals = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const formatAmount = (n) => (Number.isFinite(n) ? twoDecimals.format(n) : '—');

/** What may be typed into an amount field: digits, one point, two decimals, nine whole digits. */
export function cleanAmountInput(raw) {
  const [whole = '', ...rest] = String(raw).replace(/[^\d.]/g, '').split('.');
  const digits = whole.replace(/^0+(?=\d)/, '').slice(0, 9);
  return rest.length ? `${digits || '0'}.${rest.join('').slice(0, 2)}` : digits;
}

/** A number as an amount field holds it: 500 → "500", 12.5 → "12.5". */
export const amountText = (n) => String(Math.round(n * 100) / 100);

/**
 * The answer for `amount` of `from`, as figures: { source, targets }, each
 * { amount, currency } — the other currencies among `shown` (the rows on
 * screen), or only `target` when one was asked for. Null when there is nothing
 * to say. The sentence is composed from these (src/shared/speech.mjs), by the
 * page to show and by the server to voice.
 */
export function answerParts(amount, from, rate, target, shown = CURRENCIES) {
  if (!(amount > 0) || !(rate > 0)) return null;
  const foreign = shown.find((c) => FOREIGN.includes(c)) || 'usd';
  const values = convert(amount, from, rate, foreign);
  const wanted = target && target !== from ? [target] : shown.filter((c) => c !== from);
  if (wanted.some((c) => values[c] == null)) return null;   // a currency not on screen, with no rate for it
  return { source: { amount, currency: from }, targets: wanted.map((c) => ({ amount: values[c], currency: c })) };
}
